import React from 'react'
import QRImage from '../Images/QR.jpeg'
import { Link } from 'react-router-dom'

function Deposit() {
    return (
        <>
        <div className=' bg-[#000] min-h-screen w-[100%] flex flex-col justify-center items-center pt-6'>
               <h1 className='text-[#ffc107] text-[36px] font-bold text-center mb-5'>Deposit Funds to Your Account</h1>
               <p className='text-white font-semibold'>New to our platform? <span className='text-[#ffc107]' > <Link to='/joinnow'>Join Now</Link></span> </p>
                <div className=' w-full max-w-[1200px]  flex flex-wrap p-5 justify-between gap-4'>
                    <div className='bg-[#ffffff1a]   md:w-[48%] w-[100%] rounded-lg p-4 flex flex-col justify-center items-center '>
                        <h1 className='text-white text-[32px] font-bold'>Pay via UPI</h1>
                        <img className='w-[150px] rounded-lg mt-2' src={QRImage} alt="" />
                        <div className='bg-[#ffffff33] w-[100%] flex flex-col items-center rounded-lg p-3 mt-4'>
                            <p className='text-white font-semibold my-1'> Bank Name: <span className='font-normal'>Indusland Bank</span></p>
                            <p className='text-white font-semibold my-1'>Account Number: <span className='font-normal'>100117405115</span></p>
                            <p className='text-white font-semibold my-1'> IFSC Code: <span className='font-normal'>INDB0000008</span></p>
                            <p className='text-white font-semibold my-1'>Account Holder Name: <span className='font-normal'>JS Enterprises
                            </span></p>

                            <button className='w-[100%] bg-[#ffc107] text-[#000000] py-[4px] mt-2 rounded-lg hover:bg-[#e57300]'> Check Payment Status</button>

                        </div>
                    </div>
                    <div className='bg-[#ffffff1a] md:w-[48%] w-[100%]  rounded-lg p-4 flex flex-col justify-center  '>
                        <h1 className='text-white text-[32px] font-bold text-center'>Add Deposit Details</h1>
                        <div className='flex flex-col gap-2'>
                            <label className='text-[#ffc107] font-semibold' >Name</label>
                            <input type="text" placeholder='Enter your Name' className='py-2 px-2 rounded-lg outline-[#0075fa]' />
                            <label className='text-[#ffc107] font-semibold' >Phone Number</label>
                            <input type="text" placeholder='Enter Phone Number' className='py-2 px-2 rounded-lg outline-[#0075fa]' />
                            <label className='text-[#ffc107] font-semibold' >List of Exchanges</label>
                            <select className='py-2 px-2 rounded-lg outline-[#0075fa] w-full'>
                                <option value="">Select a Site</option>
                                <option value="silver">Silver Exch</option>
                                <option value="saffron">Saffron Exch</option>
                                <option value="all">All Panel</option>
                            </select>
                            <label className='text-[#ffc107] font-semibold' >Amount</label>
                            <input type="text" placeholder='Amount' className='py-2 px-2 rounded-lg outline-[#0075fa]' />
                            <label className='text-[#ffc107] font-semibold' >UTR ID</label>
                            <input type="text" placeholder='Enter UTR ID' className='py-2 px-2 rounded-lg outline-[#0075fa]' />
                            <button className='w-[100%] bg-[#ffc107] text-[#000000] py-[6px] mt-2 rounded-lg hover:bg-[#e57300]'> Submit Payment</button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Deposit
